/** @format */

import instance from './axios';

// user is first time on the site, create a new user id using Date.now() and store it in local storage
// if user is not first time on the site, get the user id from local storage and count the visit
export function recordUserVisit(payload) {
  return instance.post('guest/visits', payload);
}

export function addGuestAnswer(payload) {
  instance.post('guest/answer', payload).then((res) => {
    console.info(res.data);
  });
}
export function addGuestDetails(payload) {
  instance.post('guest/details', payload).then((res) => {
    console.info(res.data);
  });
}
